module.exports = __webpack_public_path__ + "static/cc-logo-dark-c5a59d6dcdfec6baa410a63754d9bb88.png";